import {RiCloseLine} from '@remixicon/react'
import classNames from 'classnames'
import {media} from 'styled-bootstrap-grid'
import styled from 'styled-components'
import {palette} from 'styled-tools'

import {styledTheme} from '@festi/common/themes'
import {getGrammaticalNumber} from '@festi/utils/strings'

const InstallmentsTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  &.blurText {
    color: transparent;
    text-shadow: 0 0 6px ${palette('blue')};
  }

  ${media.md`
    flex-direction: row;
    align-items: center;
  `}
`

const InstallmentText = styled.p`
  color: ${palette('blue')};
  font-size: 16px;
  font-weight: 500;
  white-space: nowrap;

  ${media.md`
    font-size: 20px;
  `}
`

const MonthlyPriceText = styled.p`
  color: ${palette('blue')};
  font-family: 'ElkjopHeadline', sans-serif;
  font-size: 24px;
  white-space: nowrap;

  span {
    font-family: 'ElkjopSans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: ${palette('ui60Solid')};
  }
`

const XIconWrapper = styled.div`
  display: none;

  ${media.md`
    display: block;
  `}
`

export const InstallmentsText = ({
  installments,
  averageMonthlyPayment,
  isLoading,
}: {
  installments: number
  averageMonthlyPayment: string
  isLoading: boolean
}): JSX.Element => {
  const textByGrammaticalNumber =
    getGrammaticalNumber(installments) === 'singular'
      ? 'afborgun'
      : 'afborganir'

  return (
    <InstallmentsTextWrapper className={classNames({blurText: isLoading})}>
      <InstallmentText>
        {installments} {textByGrammaticalNumber}
      </InstallmentText>
      <XIconWrapper>
        <RiCloseLine size={16} color={styledTheme.palette.ui60Solid} />
      </XIconWrapper>
      <MonthlyPriceText>
        {averageMonthlyPayment}
        <span> /mán.</span>
      </MonthlyPriceText>
    </InstallmentsTextWrapper>
  )
}
